/*  ========================================================================
    # Scripts - Sticky CTA Bar
    ========================================================================  */

/**
 * Shows the "Sticky CTA Bar" if the element is not intersecting and the is not
 * above the scrollwindow.
 */
const StickContentButton = {
  cfg: {
    body: document.body,
    contentWithStickyButtonSection: document.querySelector('.s-content-with-sticky-button'),
    stickButtonContainer: document.querySelector(
      '.s-content-with-sticky-button__fixed-button-container'
    )
  },

  handleStickyCtaBar() {
    const observer = new IntersectionObserver(elements => {
      elements.forEach(element => {
        if (element.isIntersecting) {
          this.cfg.stickButtonContainer.classList.add(
            's-content-with-sticky-button__fixed-button-container--show'
          );
        } else {
          this.cfg.stickButtonContainer.classList.remove(
            's-content-with-sticky-button__fixed-button-container--show'
          );
        }
      });
    });

    if (this.cfg.contentWithStickyButtonSection)
      observer.observe(this.cfg.contentWithStickyButtonSection);
  },

  /**
   * Initialize.
   */
  init() {
    if (this.cfg.stickButtonContainer !== undefined && this.cfg.stickButtonContainer !== null) {
      this.handleStickyCtaBar();
    }
  }
};

export default StickContentButton;
